<template>
    <div id="building-preference">
        <v-card-title class="pb-0">
            <v-icon :color="kingsGold" left>mdi-home-group</v-icon> Building Preference
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-card-subtitle class="pb-1 px-0">
                    <v-icon :color="kingsGold" left>mdi-home-group</v-icon>Building Preference (Please rank two)
                </v-card-subtitle>
                <v-alert :color="infoColor" dense icon="mdi-information" text>Please note:
                    <b>Monsignor
                        Wemple</b> residence is designated to female only.</v-alert>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.buildingOption01" hide-details
                            label="Building Preference - First Choice" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.buildingOption02" hide-details
                            label="Building Preference - Second Choice" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.buildingUnitPreference" hide-details label="Unit Preference"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-basket</v-icon>Meal Plan Information
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="item.residenceMealPlan"
                            hint="Note: These costs are approximate. Final costs are subject to Board approval."
                            label="Meal Plan" persistent-hint placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="pb-1 px-0">
                    <v-icon :color="kingsGold" left>mdi-account-group</v-icon>Roommate Requests (Optional)
                </v-card-subtitle>
                <v-alert class="mb-0" :color="infoColor" dense icon="mdi-information" text>Roommate
                    request will
                    only be honoured if both students request each other on their applications.</v-alert>
                <v-row>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="font-weight-medium px-0">
                            {{ item.buildingOption01 || 'Building Preference - First Choice' }} -
                            Roommate
                            Requests
                        </v-card-subtitle>
                        <v-alert v-if="item.roommateRequest01 && item.roommateRequest01.length == 0" :color="infoColor"
                            dense icon="mdi-information" text>
                            There are no roommate requests for the first building preference choice or the building may
                            not allow roommate requests.</v-alert>
                        <v-text-field v-for="(roommate, i) in item.roommateRequest01" :key="i" readonly
                            :label="'Roommate Name #' + (i + 1)" :value="roommate">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="font-weight-medium px-0">
                            {{ item.buildingOption02 || 'Building Preference - Second Choice' }} -
                            Roommate
                            Requests
                        </v-card-subtitle>
                        <v-alert v-if="item.roommateRequest02 && item.roommateRequest02.length == 0" :color="infoColor"
                            dense icon="mdi-information" text>
                            There are no roommate requests for the second building preference choice or the building may
                            not allow roommate requests.</v-alert>
                        <v-text-field v-for="(roommate, i) in item.roommateRequest02" :key="i" readonly
                            :label="'Roommate Name #' + (i + 1)" :value="roommate">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-card-subtitle class="px-0">
                    <v-icon :color="kingsGold" left>mdi-history</v-icon>Have you ever lived in a
                    College/University residence before?
                </v-card-subtitle>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="item.residencePrevious" hide-details
                            label="Previous residence experience" placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col v-if="item.residencePrevious == 'Yes'" cols="12">
                        <v-text-field v-model="item.residencePreviousLocation" label="Previous residence location"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                        <v-alert class="mt-3 mb-0" :color="successColor" icon="mdi-check" prominent text>I
                            authorize
                            King's University College to contact the specified residence for more information
                            regarding
                            my residence term.</v-alert>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'application-building-preference',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        successColor() {
            return '#1bc5bd';
        },
    }
}
</script>

<style scoped>
.v-card__subtitle {
    font-weight: bold;
}
</style>